import { BrainType, CLUBrainInterface, InheritanceStatus, LLMBrainInterface, NLPBrainInterface } from "@swivl-mono/types";
import _ from "lodash";
import * as React from "react";
import { useMatch } from "react-router-dom";

import { PageLoadingView } from "../../App/Layout/Loading/LoadingView";
import { BrainsModel } from "../../Models/Brains/Brains.Model";
import { NavBar } from "../../Models/NavBar/NavBar.Model";
import "./BrainsView.scss";
import CLUBrainsView from "./CLUBrainView";
import LLMBrainView from "./LLMBrainView";
import NLPBrainsView from "./NLPBrainView";

export default function BrainsView() {
  const match = useMatch("/brain/:brainSlug");
  const { brains, brainsMap } = BrainsModel.useState((state) => state);
  const brain = match && match.params && match.params.brainSlug && brainsMap ? brainsMap[match.params.brainSlug] : null;

  // const brain = React.useMemo(() => {
  //   if (!brainsMap) return null;
  //   return brainsMap[match.params.brainSlug];
  // }, [match.params, brainsMap]);

  React.useEffect(() => {
    BrainsModel.load(false);
  }, []);

  React.useEffect(() => {
    if (!brain) return;
    NavBar.set(
      <NavBar.Component.Back />,
      brain.inheritance !== InheritanceStatus.IS_PARENT ? (
        <NavBar.Component.Title
          title={brain.name}
          canEdit={true}
          onSave={async (name) => {
            let _brain = { ...brain };
            _brain.name = name;
            await BrainsModel.updateBrain(_brain, true);
          }}
        />
      ) : (
        <NavBar.Component.Title title={brain.name} />
      ),
      null,
      brain.name
    );
  }, [brain]);

  if (!brain) return <PageLoadingView />;
  if (brain.type === BrainType.NLP) {
    return <NLPBrainsView brain={brain as NLPBrainInterface} />;
  }

  if (brain.type === BrainType.CLU) {
    return <CLUBrainsView brain={brain as CLUBrainInterface} />;
  }
  if (brain.type === BrainType.LLM) {
    return <LLMBrainView brain={brain as LLMBrainInterface} />;
  }

  return <div className="BrainsView">Unknown Brain Type</div>;
}
